<template>
    <div>
        <el-menu mode="horizontal" default-active='/vendor/orders' :router="true" class="menu-bar"
                 background-color="#0a609b" text-color="#fff" active-text-color="#fef9c7">
            <el-menu-item index="/vendor/orders">Orders</el-menu-item>
            <el-menu-item index="/vendor/employee">Employee</el-menu-item>
            <el-menu-item index="/vendor/price">Price List</el-menu-item>
            <el-menu-item index="/vendor/invoice">Statement List</el-menu-item>
            <el-submenu style="float: right;margin-right: 10px" index="#">
                <template slot="title"><h2 style="display: inline-block">{{getUserName}}</h2></template>
                <el-menu-item @click="showServices" index="#">Services</el-menu-item>
                <el-menu-item @click="logOut" index="#">Logout</el-menu-item>
            </el-submenu>
        </el-menu>

        <el-dialog
                center
                title="Services"
                :visible.sync="dialogVisible"
                width="600px">
            <el-tree
                    ch
                    ref="tree"
                    :default-checked-keys="selected"
                    :data="services"
                    node-key="id"
                    :props="{label:'name', children:'subService'}"
                    show-checkbox>
            </el-tree>
        </el-dialog>
    </div>
</template>

<script>

    import {mapGetters} from "vuex";
    import store from '@/store/index'
    import {vendorServiceList} from "@/api/VendorAPI";

    export default {
        name: 'VendorBar',
        computed: mapGetters({
            getUserName: "getUserName"
        }),
        data() {
            return {
                dialogVisible: false,
                selected: [],
                services: [],

            }
        },
        methods: {
            logOut() {
                this.$router.push('/')
            }, showServices() {
                let user = store.state.userInfo;
                vendorServiceList(user.id)
                    .then(res => {
                        const data = res.data;
                        this.services = data.data
                        this.selected = data.selectedIds;
                        this.dialogVisible = true
                    })
            }
        }
    }
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
    .el-menu{
        padding: 0 10px 0 10px;
        font-weight: bold;
    }

    .el-menu-item{
        font-family: 'Helvetica', 'Arial', sans-serif;
        font-weight: bold;
        text-align: center;
    }
</style>
